export default "__VITE_ASSET__D4nIEkp0__"